// extracted by css-extract-rspack-plugin
export default {"cls1":"WorkSelectorUpload-cls1_0iz","cls2":"WorkSelectorUpload-cls2_wip WorkSelectorUpload-cls1_0iz"};